<template>
  <div class="query-home-wrap">
    <my-header
        :current-title="['发票业务', '发票查询统计', '开票数据统计及发票领用查询']"
        main-title="开票数据统计及发票领用查询"
        @back="emit('switchPage', {key: 'home'})"
    />

    <div class="content-box">

      <div class="my-alert" :class="{'hidden': hideTip}">
        <svg fill="none" viewBox="0 0 24 24" width="22" height="22" class="icon t-icon-info-circle-filled">
          <path fill="currentColor"
                d="M12 23a11 11 0 100-22 11 11 0 000 22zM11 8.5v-2h2v2h-2zm2 1.5v7.5h-2V10h2z"></path>
        </svg>
        <span
            class="txt">尊敬的纳税人，受网络波动及服务器资源配置的影响，涉及增值税发票管理系统（税务ukey、金税盘、税控盘等）的发票数据需要1-2天的传输时间，请您耐心等待。</span>
        <el-icon
            style="cursor: pointer;"
            @click="hideTip = true"
            color="#55555" size="18">
          <Close/>
        </el-icon>
      </div>

      <div class="main-box">
        <el-form :model="queryParams"
                 size="default"
                 class="my-form"
                 ref="formRef" :rules="rules" :inline="true" label-width="100px">
          <el-form-item label="发票来源"
                        prop="ticSource">
            <el-select
                v-model="queryParams.ticSource"
                style="width: 201px"
                placeholder="请选择">
              <el-option label="全部" value="全部"/>
              <el-option label="增值税发票管理系统" value="增值税发票管理系统"/>
              <el-option label="电子发票服务平台" value="电子发票服务平台"/>
            </el-select>
          </el-form-item>

          <el-form-item label="票种" prop="categoryCode">
            <el-select
                multiple
                collapse-tags
                clearable
                v-model="queryParams.categoryCode"
                style="width: 201px"
                placeholder="请选择">
              <template #header>
                <el-checkbox
                    v-model="checkCategoryCodeAll"
                    :indeterminate="categoryCodeIndeterminate"
                    @change="handleCategoryCodeCheckAll"
                >
                  全选
                </el-checkbox>
              </template>
              <el-option
                  v-for="(item, idx) in categoryTypeList"
                  :key="idx"
                  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>

          <el-form-item label="起始时间" prop="startTime">
            <el-date-picker
                v-model="queryParams.startTime"
                type="month"
                :disabled-date="disableMakeStart"
                style="width: 201px"
                value-format="YYYY-MM"
                placeholder="请选择"
            />
          </el-form-item>

          <el-form-item label="终止时间" prop="endTime">
            <el-date-picker
                v-model="queryParams.endTime"
                type="month"
                :disabled-date="disableMakeEnd"
                style="width: 201px"
                value-format="YYYY-MM"
                placeholder="请选择"
            />
          </el-form-item>

          <el-form-item style="padding-left: 25px;">
            <el-button type="info" @click="reset">重置</el-button>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button
                text
                type="primary"
                icon="ArrowUp">收起
            </el-button>
          </el-form-item>
        </el-form>

        <!--第1表格开始-->
        <div class="opera-row" style="margin-top: 20px;">
          <h3>按发票种类统计（领票）</h3>
          <div class="grow"></div>
          <el-button>自定义列</el-button>
        </div>

        <el-table
            ref="tableRef"
            :data="showTableList1"
            style="margin-top: 10px;"
            border
        >
          <el-table-column type="index" label="序号" fixed="left" align="center" width="60"/>

          <el-table-column label="发票种类" align="left" prop="categoryName" min-width="210"/>

          <el-table-column label="发票期初库存份数" align="center" min-width="150">
            <template #default>
              0
            </template>
          </el-table-column>

          <el-table-column label="购进发票份数" align="center" min-width="150">
            <template #default>
              0
            </template>
          </el-table-column>

          <el-table-column label="退回发票份数" align="center" min-width="130">
            <template #default>
              0
            </template>
          </el-table-column>

          <el-table-column label="空白废票份数" align="center" min-width="130">
            <template #default>
              0
            </template>
          </el-table-column>

          <el-table-column label="发票期末库存份数" align="center" min-width="150">
            <template #default>
              0
            </template>
          </el-table-column>

          <el-table-column label="统计日期" align="center" prop="statistDate" min-width="150"/>
        </el-table>

        <div class="paginate-wrap">
          <span class="total">共 {{ pageTotal1 }} 条</span>
          <pagination
              :total="pageTotal1"
              v-model:page="queryParams.pageNum1"
              v-model:limit="queryParams.pageSize1"
              layout="sizes,prev, pager, next, jumper"
          />
        </div>
        <!--第1表格结束-->

        <!--第2表格开始-->
        <div class="opera-row" style="margin-top: 20px;">
          <h3>按发票种类统计（开票）</h3>
          <div class="grow"></div>
          <el-button>自定义列</el-button>
        </div>

        <el-table
            ref="tableRef"
            :data="showTableList2"
            style="margin-top: 10px;"
            border
        >
          <el-table-column type="index" label="序号" fixed="left" align="center" width="60"/>

          <el-table-column label="发票种类" align="left" prop="categoryName" min-width="210"/>

          <el-table-column label="正数发票份数" align="center" prop="positiveTicCount" min-width="170"/>

          <el-table-column label="正数废票份数" align="center" min-width="170">
            <template #default>
              0
            </template>
          </el-table-column>

          <el-table-column label="负数发票份数" align="center" prop="negativeTicCount" min-width="170"/>

          <el-table-column label="负数废票份数" align="center" min-width="170">
            <template #default>
              0
            </template>
          </el-table-column>

          <el-table-column label="统计日期" align="center" prop="statistDate" min-width="150"/>
        </el-table>

        <div class="paginate-wrap">
          <span class="total">共 {{ pageTotal2 }} 条</span>
          <pagination
              :total="pageTotal2"
              v-model:page="queryParams.pageNum2"
              v-model:limit="queryParams.pageSize2"
              layout="sizes,prev, pager, next, jumper"
          />
        </div>
        <!--第2表格结束-->

        <!--第3表格开始-->
        <div class="opera-row" style="margin-top: 20px;">
          <h3>按税率/征收率统计</h3>
          <div class="grow"></div>
          <el-button>自定义列</el-button>
        </div>

        <el-table
            ref="tableRef"
            :data="showTableList3"
            style="margin-top: 10px;"
            border
        >
          <el-table-column type="index" label="序号" fixed="left" align="center" width="60"/>

          <el-table-column label="发票种类" align="left" prop="categoryName" min-width="210"/>

          <el-table-column label="税率/征收率" align="center" min-width="120"/>

          <el-table-column label="开具蓝字发票金额" align="center" prop="blueAmountTotal" min-width="150">
            <template #default="{row}">
              <span>{{ row.blueAmountTotal != null && row.blueAmountTotal.toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="开具蓝字发票税额" align="center" prop="blueTaxTotal" min-width="150">
            <template #default="{row}">
              <span>{{ row.blueTaxTotal != null && row.blueTaxTotal.toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="作废蓝字发票金额" align="center" min-width="150">
            <template #default>
              0.00
            </template>
          </el-table-column>

          <el-table-column label="作废蓝字发票税额" align="center" min-width="150">
            <template #default>
              0.00
            </template>
          </el-table-column>

          <el-table-column label="开具红字发票金额" align="center" prop="redAmountTotal" min-width="150">
            <template #default="{row}">
              <span>{{ row.redAmountTotal != null && row.redAmountTotal.toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="开具红字发票税额" align="center" prop="redTaxTotal" min-width="150">
            <template #default="{row}">
              <span>{{ row.redTaxTotal != null && row.redTaxTotal.toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="作废红字发票金额" align="center" min-width="150">
            <template #default>
              0.00
            </template>
          </el-table-column>

          <el-table-column label="作废红字发票税额" align="center" min-width="150">
            <template #default>
              0.00
            </template>
          </el-table-column>

          <el-table-column label="实际开具发票金额" align="center" prop="actualAmountTotal" min-width="150">
            <template #default="{row}">
              <span>{{ row.actualAmountTotal != null && row.actualAmountTotal.toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="实际开具发票税额" align="center" prop="actualTaxTotal" min-width="150">
            <template #default="{row}">
              <span>{{ row.actualTaxTotal != null && row.actualTaxTotal.toFixed(2) }}</span>
            </template>
          </el-table-column>

          <el-table-column label="统计日期" align="center" prop="statistDate" min-width="150"/>
        </el-table>
        <!--第3表格结束-->


      </div>
    </div>

    <footer class="footer">
      <img src="https://static.rhkj.com/renhe_fe/other/333.png">
    </footer>
  </div>
</template>

<script setup>
import myHeader from "../cmp/myHeader.vue";
import dayjs from "dayjs";
import {categoryTypeList, useAllInvoice} from "./allInvoiceSummary.js";
import Big from "big.js";
import {$emit} from "vue-happy-bus";

const emit = defineEmits(['switchPage'])
const hideTip = ref(false)
const queryParams = reactive({
  pageSize1: 50,
  pageNum1: 1,
  pageSize2: 50,
  pageNum2: 1,
})
const rules = reactive({
  ticSource: {required: true, message: '发票来源必填', trigger: ['blur', 'change']},
  categoryCode: {required: true, message: '票种必填', trigger: ['blur', 'change']},
  startTime: {required: true, message: '起始时间必填', trigger: ['blur', 'change']},
  endTime: {required: true, message: '终止时间必填', trigger: ['blur', 'change']},
})

const formRef = ref()

const showTableList1 = ref([])
const showTableList2 = ref([])
const showTableList3 = ref([])

const pageTotal1 = ref(0)
const pageTotal2 = ref(0)

const {initialData} = useAllInvoice()

function queryData() {
  formRef.value.validate(valid => {
    if (valid) {

      const resData = initialData.value
          .filter(f => {
            let pass = true
            if (queryParams.ticSource && queryParams.ticSource != '全部') {
              pass = pass && (f.ticSource == queryParams.ticSource)
            }
            if (queryParams.categoryCode?.length) {
              pass = pass && (queryParams.categoryCode.includes(f.categoryCode))
            }
            if (queryParams.startTime || queryParams.endTime) {
              const c = dayjs(f.createTime, 'YYYY-MM-DD HH:mm:ss')
              const s = dayjs(queryParams.startTime || '1970-01', 'YYYY-MM').startOf('month')
              const e = dayjs(queryParams.endTime || '2099-12', 'YYYY-MM').endOf('month')
              pass = pass && ((s.isBefore(c) || s.isSame(c)) && (e.isAfter(c) || e.isSame(c)))
            }
            return pass
          })
          .reduce((prev, item) => { // 按照发票类型分组展示，并分组求和
            const find = prev.find(s => s.categoryCode == item.categoryCode)
            if (find) {
              find.originRows.push(item)
              if (item.amount > 0) { // 蓝字发票
                find.positiveTicCount++
                find.blueAmountTotal = parseFloat(new Big(find.blueAmountTotal).plus(item.Number_amount).toString())
                find.blueTaxTotal = parseFloat(new Big(find.blueTaxTotal).plus(item.Number_TaxAmount).toString())
              } else {
                find.negativeTicCount++
                find.redAmountTotal = parseFloat(new Big(find.redAmountTotal).plus(item.Number_amount).toString())
                find.redTaxTotal = parseFloat(new Big(find.redTaxTotal).plus(item.Number_TaxAmount).toString())
              }
              find.actualAmountTotal = parseFloat(new Big(find.actualAmountTotal).plus(item.Number_amount).toString())
              find.actualTaxTotal = parseFloat(new Big(find.actualTaxTotal).plus(item.Number_TaxAmount).toString())
            } else {
              prev.push({
                categoryCode: item.categoryCode,
                categoryName: ['', '电子发票（普通发票）', '电子发票（增值税专用发票）'][parseInt(item.categoryCode)],
                originRows: [item],
                positiveTicCount: item.Number_amount > 0 ? 1 : 0,
                negativeTicCount: item.Number_amount < 0 ? 1 : 0,
                blueAmountTotal: parseFloat(new Big(item.Number_amount > 0 ? item.Number_amount : 0).toString()),
                blueTaxTotal: item.Number_amount > 0 ? item.Number_TaxAmount : 0,
                redAmountTotal: item.Number_amount < 0 ? item.Number_amount : 0,
                redTaxTotal: item.Number_amount < 0 ? item.Number_TaxAmount : 0,
                actualAmountTotal: parseFloat(new Big(item.Number_amount).toString()),
                actualTaxTotal: item.Number_TaxAmount,
                statistDate: dayjs().format('YYYY-MM-DD'),
              })
            }
            return prev
          }, [])

      showTableList1.value = resData
      pageTotal1.value = resData.length
      showTableList2.value = resData
      pageTotal2.value = resData.length
      showTableList3.value = resData
      console.log('汇总后数据', resData)

      $emit("exeSaveQa"); // 查询后，提交题目
    }
  })
}

function reset() {
  formRef.value && formRef.value.resetFields();
}

const getGrandchildValue = inject("getGrandchildValue");
getGrandchildValue.value.getData = (byUser) => {
  if (!Boolean(byUser)) { // 非用户主动保存数据，不触发修改solution，即不保存
    return {}
  }
  return {
    solution: JSON.stringify({
      userAnswer: showTableList1.value,
    }),
  };
};

getGrandchildValue.value.getResetData = () => {
  return {
    solution: "",
  };
};

const checkCategoryCodeAll = ref(false)
const categoryCodeIndeterminate = ref(false)

watch(() => queryParams.categoryCode, (val) => {
  if (!val || val.length === 0) {
    checkCategoryCodeAll.value = false
    categoryCodeIndeterminate.value = false
  } else if (val.length === 19) {
    checkCategoryCodeAll.value = true
    categoryCodeIndeterminate.value = false
  } else {
    categoryCodeIndeterminate.value = true
  }
})

const handleCategoryCodeCheckAll = (val) => {
  categoryCodeIndeterminate.value = false
  if (val) {
    queryParams.categoryCode = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19']
  } else {
    queryParams.categoryCode = []
  }
}

function disableMakeStart(date) {
  // 开始时间不能大于结束时间
  if (queryParams.endTime && dayjs(date).isAfter(dayjs(queryParams.endTime, 'YYYY-MM').startOf('month'))) {
    return true
  }
  return false
}

function disableMakeEnd(date) {
  // 开始时间不能大于结束时间
  if (queryParams.startTime && dayjs(date).isBefore(dayjs(queryParams.startTime, 'YYYY-MM').startOf('month'))) {
    return true
  }
  return false
}
</script>


<style scoped lang="scss">
.query-home-wrap {
  height: 100vh;
  overflow-y: auto;

  .content-box {
    padding-top: 24px;
    background-color: rgb(238, 238, 238);
    min-height: calc(100vh - 136px - 152px - 5px);

    .my-alert {
      display: flex;
      align-items: center;
      padding: 16px 24px;
      margin: 0 24px 20px;
      background-color: #d2e7fb;
      font-size: 14px;
      line-height: 22px;
      color: #666666;

      .icon {
        color: rgb(66, 133, 244);
      }

      .txt {
        width: 0;
        flex-grow: 1;
        margin-left: 8px;
      }

      &.hidden {
        display: none;
      }
    }

    .main-box {
      background-color: #FFFFFF;
      padding: 24px;
      margin: 0 24px 0 24px;

      .opera-row {
        display: flex;
        //padding: 0 20px;

        .grow {
          flex-grow: 1;
        }

        > h3 {
          color: #111111;
          font-weight: 700;
        }
      }

      .paginate-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15px;

        .total {
          color: #666666;
          font-size: 14px;
        }
      }
    }
  }

  .footer {
    background-color: rgb(238, 238, 238);
    display: flex;
    justify-content: center;
    padding: 30px 0;
    opacity: 0.9;
  }
}
</style>
